module.exports = __webpack_public_path__ + "img/background-study-type.d6ce5200.jpg";